import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/Order/:token" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
